import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Home, Crown, Car, Phone, Plus } from "lucide-react";
import BUSINESS from "../config/business";

/**
 * Persistent bottom nav for the mobile PWA.
 * Center "Book" button is a raised circular gold button.
 */
export default function MobileBottomNav() {
  const navigate = useNavigate();
  const linkCls = ({ isActive }) =>
    `flex flex-col items-center gap-0.5 py-2 flex-1 text-[9px] tracking-widest transition-colors ${
      isActive ? "text-[#39D6FF]" : "text-white/40 hover:text-white/70"
    }`;

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="fixed bottom-0 inset-x-0 z-40 h-20 pb-safe"
      style={{
        background: "linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.95) 100%)",
        backdropFilter: "blur(24px)",
        borderTop: "1px solid rgba(57,214,255,0.25)",
      }}
    >
      <div className="relative h-full flex items-stretch">
        <NavLink to="/m" end className={linkCls} data-testid="mnav-home">
          <Home size={18} strokeWidth={1.8} /> <span>HOME</span>
        </NavLink>
        <NavLink to="/m/chauffeur" className={linkCls} data-testid="mnav-chauffeur">
          <Crown size={18} strokeWidth={1.8} /> <span>CHAUFFEUR</span>
        </NavLink>

        {/* Center raised gold Book button */}
        <button
          type="button"
          onClick={() => navigate("/m/chauffeur?book=1")}
          data-testid="mnav-book"
          aria-label="Book a ride"
          className="absolute left-1/2 -translate-x-1/2 -top-5 w-14 h-14 rounded-full flex items-center justify-center active:scale-95 transition-transform"
          style={{
            background: "linear-gradient(180deg, #F8FAFC 0%, #39D6FF 50%, #39D6FF 100%)",
            boxShadow: "0 8px 24px -4px rgba(57,214,255,0.6), 0 0 0 4px #000, inset 0 1px 0 rgba(255,255,255,0.6)",
          }}
        >
          <Plus size={26} strokeWidth={2.5} className="text-black" />
        </button>
        <div className="flex-1" aria-hidden="true" />

        <NavLink to="/m/rentals" className={linkCls} data-testid="mnav-rentals">
          <Car size={18} strokeWidth={1.8} /> <span>RENTALS</span>
        </NavLink>
        <a
          href={`tel:${BUSINESS.phoneTel}`}
          data-testid="mnav-call"
          className="flex flex-col items-center gap-0.5 py-2 flex-1 text-[9px] tracking-widest text-white/40 hover:text-white/70"
        >
          <Phone size={18} strokeWidth={1.8} /> <span>CALL</span>
        </a>
      </div>
    </nav>
  );
}
